import React from 'react'
import { RouterProvider } from 'react-router-dom'

import './index.css'

// Vendors
import 'firebase/auth'
import './config/i18next'
import './config/hotjar'
import { QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from '@mui/material/styles'
import { Provider } from 'react-redux'

// Components
import { AuthProvider } from './utils/Firebase/context/AuthContext'

//Config
import { router } from './routes'
import theme from './theme/theme'
import { queryClient } from './config/reactQuery'
import { auth } from './config/firebase'
import { appStore } from './store/appStore'

function App() {
	return (
		<Provider store={appStore}>
			<AuthProvider auth={auth}>
				<ThemeProvider theme={theme}>
					<QueryClientProvider client={queryClient}>
						<RouterProvider router={router} />
					</QueryClientProvider>
				</ThemeProvider>
			</AuthProvider>
		</Provider>
	)
}

export default App
